import { OfferingForm } from '@/components/features/offerings/OfferingForm'
import { NavHeader } from '@/components/features/shared/NavHeader'
import { Button } from '@/components/ui/button'
import { OfferingDto } from '@/domain/offerings/offering'
import { useOffering, useUpdateOffering } from '@/hooks/api/useOfferings'
import { Paths } from '@/routes/paths'
import { useNavigate } from '@tanstack/react-router'
import { PageContainer } from '@/components/features/shared/PageContainer'

interface EditOfferingPageProps {
  offeringId: string
}

export const EditOfferingPage = ({ offeringId }: EditOfferingPageProps) => {
  const navigate = useNavigate()
  const updateOffering = useUpdateOffering()
  const { data: offering, isLoading } = useOffering(offeringId)

  const handleSubmit = async (values: OfferingDto) => {
    try {
      await updateOffering.mutateAsync({ id: offeringId, data: { ...values } })
      navigate({ to: `${Paths.Management.Offerings}/${offeringId}` })
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    navigate({ to: `${Paths.Management.Offerings}` })
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!offering) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">No se pudo cargar el servicio</p>
        <Button variant="outline" className="mt-4" onClick={handleCancel}>
          Volver
        </Button>
      </div>
    )
  }

  return (
    <PageContainer>
      <NavHeader>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Editar Servicio</h1>
          <p className="text-muted-foreground">
            Modifica los detalles del servicio seleccionado
          </p>
        </div>
      </NavHeader>
      <div className="py-6 max-w-4xl border p-6 rounded-xl">
        <OfferingForm
          defaultValues={{
            name: offering.name,
            code: offering.code,
            serviceType: offering.serviceType,
            description: offering.description || '',
            offeringType: offering.offeringType,
            billingFrequency: offering.billingFrequency,
            basePrice: offering.basePrice,
            currency: offering.currency,
            taxRate: offering.taxRate || 0,
            isTaxable: offering.isTaxable,
            isInvoiceable: offering.isInvoiceable,
            hasMultipleOffered: offering.hasMultipleOffered,
            hasPaymentPlanAvailable: offering.hasPaymentPlanAvailable,
            hasAgePricing: offering.hasAgePricing,
            isAdditional: offering.isAdditional,
          }}
          onSubmit={handleSubmit}
          isSubmitting={updateOffering.isPending}
          submitButtonText="Guardar cambios"
          onCancel={handleCancel}
        />
      </div>
    </PageContainer>
  )
}
